<template>
	<app>
		<flow-node :node="nodeList" :current="currentNode" :reject="rejectNode"></flow-node>
		<c-title>项目详情</c-title>
		<c-detail>
			<c-detail-item label="项目名称">
				{{detailInfo.name}}
			</c-detail-item>
			<c-detail-item label="项目状态">
				<span v-if="projectState[detailInfo.state]" :style="{'color': projectState[detailInfo.state].color}">{{projectState[detailInfo.state].name}}</span>
			</c-detail-item>
			<c-detail-item label="项目编号">
				{{detailInfo.code}}
			</c-detail-item>
			<c-detail-item label="项目所属行业">
				{{detailInfo.sshy}}
			</c-detail-item>
			<c-detail-item label="建设地址">
				{{detailInfo.xm_address}}
			</c-detail-item>
			<c-detail-item label="业主单位">
				{{detailInfo.yzdw_name}}
			</c-detail-item>
			<c-detail-item label="业主单位地址">
				{{detailInfo.yzdw_address}}
			</c-detail-item>
			<c-detail-item label="业主单位联系人">
				{{detailInfo.yzdw_lxr}}<span v-if="detailInfo.yzdw_lxdh">（{{detailInfo.yzdw_lxdh}}）</span>
			</c-detail-item>
			<c-detail-item label="组织部门">
				{{detailInfo.yzdw_organization_name}}
			</c-detail-item>
			<c-detail-item label="被保险人">
				{{detailInfo.bbxr_name}}
			</c-detail-item>
			<c-detail-item label="被保险人组织代码">
				{{detailInfo.bbxr_jgdm}}
			</c-detail-item>
			<c-detail-item label="招标文件">
				<c-file :src="detailInfo.files_path"></c-file>
			</c-detail-item>
			<c-detail-item label="招标代理费付款方">
				{{detailInfo.zbdl_money_user_type == 1 ? '企业' : '业主'}}
			</c-detail-item>
			<c-detail-item label="备注说明">
				{{detailInfo.remark}}
			</c-detail-item>
		</c-detail>
		
		<c-title v-if="detailInfo.state == 4">中标企业信息</c-title>
		<c-detail v-if="detailInfo.state == 4">
			<c-detail-item label="工期">
				<span v-if="detailInfo.sggq">{{detailInfo.sggq}}天</span>
			</c-detail-item>
			<c-detail-item label="中标单位">
				{{detailInfo.zbqy_name}}
			</c-detail-item>
			<c-detail-item label="中标金额">
				{{detailInfo.zb_money}}
			</c-detail-item>
			<c-detail-item label="中标单位地址">
				{{detailInfo.zbqy_address}}
			</c-detail-item>
			<c-detail-item label="中标通知书">
				<c-file :src="detailInfo.zb_path"></c-file>
			</c-detail-item>
			<c-detail-item label="中标企业法人">
				{{detailInfo.zbqy_user_realname}}
			</c-detail-item>
			<c-detail-item label="项目经理">
				{{detailInfo.xmjl_xm}}<span v-if="detailInfo.xmjl_lxdh">（{{detailInfo.xmjl_lxdh}}）</span>
			</c-detail-item>
			<c-detail-item label="中标企业联系电话">
				{{detailInfo.zbqy_user_phone}}
			</c-detail-item>
			<c-detail-item label="技术总工">
				{{detailInfo.jszg_xm}}<span v-if="detailInfo.jszg_lxdh">（{{detailInfo.jszg_lxdh}}）</span>
			</c-detail-item>
			<c-detail-item label="监理单位">
				{{detailInfo.jldw_name}}
			</c-detail-item>
			<c-detail-item label="安全员">
				{{detailInfo.aqy_xm}}<span v-if="detailInfo.aqy_lxdh">（{{detailInfo.aqy_lxdh}}）</span>
			</c-detail-item>
			<c-detail-item label="监理单位地址">
				{{detailInfo.jldw_address}}
			</c-detail-item>
			<c-detail-item label="施工员">
				{{detailInfo.sgy_xm}}<span v-if="detailInfo.sgy_lxdh">（{{detailInfo.sgy_lxdh}}）</span>
			</c-detail-item>
			<c-detail-item label="企业需购买保函">
				<b style="color: #E63633;">{{insurance}}</b>
			</c-detail-item>
			<c-detail-item label="质检员">
				{{detailInfo.zjy_xm}}<span v-if="detailInfo.zjy_lxdh">（{{detailInfo.zjy_lxdh}}）</span>
			</c-detail-item>
			<c-detail-item label="项目签约截止日">
				{{detailInfo.qy_last_date}}
			</c-detail-item>
			<c-detail-item label="备注说明">
				{{detailInfo.zb_remark}}
			</c-detail-item>
		</c-detail>
		
		<c-title v-if="detailInfo.state == 4">项目关联保函</c-title>
		<c-detail v-if="detailInfo.state == 4">
			<div slot="custom">
				<detail-card v-for="(item, i) in insuranceList" :key="i">
					<div class="name flex-between-center">
						<div>{{item.bx_type_name}}</div>
						<div class="state" :style="{'color': insuranceState[item.state].color}">
							<i class="tf" style="margin-right: .3em;">{{insuranceState[item.state].icon}}</i>{{insuranceState[item.state].name}}
						</div>
					</div>
					<button-group v-if="item.state == 0 && power('7')">
						<c-button @click="navigateTo('/insurance_select', {projectId: id, type: item.bx_type_id})">我要办理</c-button>
					</button-group>
					<div v-else>
						<div class="info">被保险人：{{item.bbxr_name}}</div>
						<div class="info">保险额度：<span v-if="item.bd_money">{{item.bd_money}}元</span></div>
						<div v-if="item.bx_bd_state_date" class="info">保单有效期：{{item.bx_bd_state_date}} - {{item.bx_bd_end_date}}</div>
						<div v-if="item.bx_bd_state_date" class="info">
							距离保单过期：<span v-if="item.exp_date >= 0" style="color: #f00;">还有{{item.exp_date}}天</span>
							<span v-else style="color: #f00;">已过期</span>
						</div>
					</div>
				</detail-card>
			</div>
		</c-detail>
		
		<c-title>创建流程</c-title>
		<c-detail>
			<timeline slot="custom" :data="timeline"></timeline>
		</c-detail>
		
		<button-group slot="foot">
			<c-button v-if="biddingButton" @click="navigateTo('/project_bidding', {id: detailInfo.id})">设置中标企业</c-button>
			<c-button v-if="personButton" @click="navigateTo('/person_change_apply', {projectId: detailInfo.id})">设置项目人员</c-button>
		</button-group>
	</app>
</template>

<script>
	import flowNode from '@/components/module/flow_node.vue'
	import timeline from '@/components/module/timeline.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			flowNode,
			timeline
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				nodeList: [{
					name: '创建项目'
				}, {
					name: '(业主单位)确认'
				}, {
					name: '设置中标企业'
				}, {
					name: '创建成功'
				}],
				detailInfo: {},
				insurance: '',
				insuranceList: [],
				timeline: ''
			}
		},
		
		computed: {
			...mapGetters(['power', 'projectState', 'insuranceState']),
			
			currentNode() {
				return [31, 32].includes(this.detailInfo.state) ? 3 : this.detailInfo.state;
			},
			
			rejectNode() {
				return this.detailInfo.state == 1 ? 2 : 0;
			},
			
			biddingButton() {
				return this.detailInfo.state == 3 && this.power('5');
			},
			
			personButton() {
				return this.detailInfo.jldw_name && this.detailInfo.set_ry_count == 0 && this.power('7');
			}
		},
		
		mounted() {
			this.request({
				url: '/project/detail',
				data: {
					project_id: this.id
				},
				success: data => {
					this.detailInfo = data.project_info;
					this.insurance = Array.from(data.bx_list, item => {
						return item.bx_type_name;
					}).join('，');
					this.insuranceList = data.bx_list;
					this.timeline = Array.from(data.logList, item => {
						return {
							date: item.create_date,
							content: `[${item.create_user_name}] ${item.remark}`
						}
					});
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
</style>
